import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DocumentService } from 'src/app/_services/document.services';
import { AppConfig } from 'src/assets/config/config/app-config';
import { User } from 'src/app/_models';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { DomSanitizer } from '@angular/platform-browser';
import { saveAs } from 'file-saver';
import { HttpClient } from '@angular/common/http';


@Component({
  selector: 'app-fileView',
  templateUrl: './fileView.component.html',
  styleUrls: ['./fileView.component.scss']
})


export class FileViewComponent implements OnInit {
  @Input() documentID: String;
  @Input() versionNumber: number
  @Input() documentType: String;
  @Input() fileName: String;
  @Input() searchText: string;

  appError: String = null;
  fileUrl: string;
  encodedUrl: string;
  imageViewer: boolean = false;
  googleViewer: boolean = false;
  loading: boolean = false;
  archive: boolean = false;
  restore: boolean = false;
  isDocumentAvailable: boolean = false;
  isDWGFile:boolean = false;
  currentUser: User;


  constructor(
    private documentSvc: DocumentService,
    private snackBar: MatSnackBar,
    private config: AppConfig,
    private authenticationService: AuthenticationService,
    public sanitizer: DomSanitizer,
    private httpClient: HttpClient
  ) { 
    this.currentUser = this.authenticationService.currentUserValue;
  }

 

  ngOnInit(): void {
    console.log(this.fileName)
    this.viewDocument();    
  }

  viewDocument() {
    console.log("doc id " + this.documentID + " Object " + this.documentType);
    this.appError = null;
    var officeViewerTypes = ["application/vnd.openxmlformats-officedocument.presentationml.presentation", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.openxmlformats-officedocument.wordprocessing", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"]
    var imageViewerTypes = ["image/tiff", "image/png", "image/jpeg", "image/jpg"]
    var syncFusionViewerTypes = ["image/tiff", "application/vnd.openxmlformats-officedocument.wordprocessing", "application/vnd.openxmlformats-officedocument.wordprocessingml.document", "application/msword"]
    var filePreviewInSyncfusion = this.config.getConfig('fileViewSyncfusion')
    this.loading = true;
    this.documentSvc.viewVersionDocument(this.documentID, this.versionNumber)
      .subscribe(
        resp => {
          if (resp.length > 1) {
            if (JSON.stringify(resp).includes("Document is in Glacier storage. Please request for retrieval")) {
              this.archive = true;              
            } else if (JSON.stringify(resp).includes("Restoration has been requested. Please check status")) {
              this.restore = true;              
            } else {
              var url = resp.slice(5);
              if (resp.includes("google")) {
                this.fileUrl = "https" + url;
                console.log(this.fileUrl)                
              } else {
                let syncFusionURL = this.config.getConfig('syncfusionUrl')
                if (filePreviewInSyncfusion) {
                  // Searchable Option is disabled for now
                  // if (this.searchText && this.searchText != ""){
                  //   this.fileUrl = `${syncFusionURL}?&docId=${this.documentID};${this.documentType};${this.currentUser.username};&searchText=${this.searchText}`;
                  // }
                  // else{
                    
                  // }
                  // this.fileUrl = `${syncFusionURL}?&documentId=${this.documentID}&fileType=${this.documentType}`;
                  if (syncFusionViewerTypes.indexOf(this.documentType.toString()) == -1) {
                    this.fileUrl = url + '#view=FitH&zoom=80&toolbar=0&navpanes=0&scrollbar=1';
                  } else {                    
                    this.fileUrl = `${syncFusionURL}?&docId=${this.documentID};${this.documentType};${this.currentUser.username}`;
                  }
                } else {
                  if (officeViewerTypes.indexOf(this.documentType.toString()) !== -1) {
                    this.encodedUrl = encodeURIComponent(url);
                    //this.iFrameUrl = 'https://docs.google.com/viewer?url=' + this.encodedUrl + '&embedded=true';
                    //'https://view.officeapps.live.com/op/embed.aspx?src='
                    let fURL = this.config.getConfig('fileUrl');
                    this.fileUrl = `${fURL}${this.encodedUrl}&embedded=true`; 
                    //console.log(this.fileUrl);
                  }
                  else if (imageViewerTypes.indexOf(this.documentType.toString()) !== -1) {
                    this.fileUrl = url;
                    this.imageViewer = true;                    
                  }              
                  else if (url.includes('.dwg') || url.includes('.DWG')){
                    this.fileUrl = "https://docuedge-index-ui.s3.us-east-2.amazonaws.com/dwg-viewer.html?name="+this.fileName;
                  } else{
                    this.fileUrl = url + '#view=FitH&zoom=80&toolbar=0&navpanes=0&scrollbar=1';
                  }                  
                }                          
                this.isDocumentAvailable = true
              }
              this.loading = false;
              //this.googleViewer = true;
            }
          } else {
            this.loading = false;
            this.isDocumentAvailable = false;            
          }                   
        },
        error => {
          this.loading = false;          
          this.isDocumentAvailable = false;
          //console.log("Error " + error.error);
          var errObj = JSON.parse(error.error)
          if (error.error['status'] = 400) {
            this.appError = errObj.message
          }
        });
  }

  retrieveGlacierDocument() {

    var request = {
      "docid": [this.documentID]
    }
    this.documentSvc.retrieveGlacierDocuments(request).subscribe(
      response => {
        this.snackBar.open("Restoration request for the selected document is placed successfully. The restore status can be tracked from 'Glacier' tab", "Close", {
          duration: 20000
        });
        console.log("Response " + response);
      });
    console.log(request);
  }

  


}